import React from "react";

const Logout = () => {
	return (
		<>
			{/* Logout wrapper */}
			<div className="logout-wrapper">
				<button className="logout-btn">Log Out</button>
			</div>
			{/* Logout wrapper */}
		</>
	);
};

export default Logout;
